import axiosInstance from "../Axios";

const getWfh = (pageNo = 1, params) => {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }

    if (params.export) {
      return axiosInstance.get("/wfh", {
        params: queryParams,
        responseType: "blob",
      });
    }

    return axiosInstance.get("/wfh", { params: queryParams });
  } catch (error) {
    console.error("Error fetching wfh data:", error);
    throw error;
  }
};

const submitWfh = (data) => {
  try {
    return axiosInstance.post("/wfh/add-edit", data);
  } catch (error) {
    console.error("Error submitting wfh data:", error);
    throw error;
  }
};

const approveRejectCancel = (id, action, reason = "") => {
  try {
    const data = {
      id,
      action,
      reason,
    };

    return axiosInstance.patch("/wfh/approve-reject-cancel", data);
  } catch (error) {
    console.log("error in wfh actions", error);
    throw error;
  }
};

const getWfhById = (id) => {
  try {
    return axiosInstance.get(`/wfh/details/${id}`);
  } catch (error) {
    console.error("Error fetching wfh by ID:", error);
    throw error;
  }
};

export { getWfh, submitWfh, approveRejectCancel, getWfhById };
